import React from 'react';
import { useNavigate } from 'react-router-dom';

const ESTADO = {
    Pendiente: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200',
    Asignado: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
    'En Proceso': 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
    'Esperando Usuario': 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
    Resuelto: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
    Cerrado: 'bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-300',
    Cancelado: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
};
const PRIORIDAD = {
    crítica: 'border-red-300 text-red-700 bg-red-50 dark:bg-red-900/20 dark:text-red-300',
    alta: 'border-orange-300 text-orange-700 bg-orange-50 dark:bg-orange-900/20 dark:text-orange-300',
    media: 'border-yellow-300 text-yellow-700 bg-yellow-50 dark:bg-yellow-900/20 dark:text-yellow-300',
    baja: 'border-green-300 text-green-700 bg-green-50 dark:bg-green-900/20 dark:text-green-300',
};

const hace = (d) => {
    if (!d) return '—';
    const min = Math.floor((Date.now() - new Date(d)) / 60000);
    if (min < 1) return 'ahora';
    if (min < 60) return `hace ${min} min`;
    const h = Math.floor(min / 60);
    if (h < 24) return `hace ${h} h`;
    return `hace ${Math.floor(h / 24)} d`;
};
const nombreAgente = (t) => {
    const a = t.asignadoA;
    if (!a) return t.asignadoAId ? 'Técnico' : null;
    return [a.nombre, a.apellido].filter(Boolean).join(' ') || a.username || a.email || 'Técnico';
};

export default function TicketsTabla({ tickets, onAutoasignar, puedeAutoasignar }) {
    const navigate = useNavigate();
    return (
        <div className="bg-white dark:bg-gray-850 rounded-xl border border-gray-200 dark:border-gray-800 shadow-xs overflow-hidden">
            <div className="overflow-x-auto">
                <table className="min-w-full text-sm">
                    <thead className="bg-gray-50 dark:bg-gray-800/60 text-[11px] uppercase tracking-wider text-gray-500 dark:text-gray-400">
                        <tr>
                            <th className="text-left font-semibold px-4 py-3 w-16">#</th>
                            <th className="text-left font-semibold px-3 py-3">Solicitud</th>
                            <th className="text-left font-semibold px-3 py-3 hidden lg:table-cell">Solicitante</th>
                            <th className="text-left font-semibold px-3 py-3">Prioridad</th>
                            <th className="text-left font-semibold px-3 py-3">Estado</th>
                            <th className="text-left font-semibold px-3 py-3 hidden md:table-cell">Asignado a</th>
                            <th className="text-right font-semibold px-4 py-3 hidden sm:table-cell">Creado</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                        {tickets.map((t) => {
                            const agente = nombreAgente(t);
                            const cat = t.categoria?.nombre || t.categoria || 'Soporte General';
                            const solicitante = t.creadoPor?.nombre ? `${t.creadoPor.nombre} ${t.creadoPor.apellido || ''}`.trim() : t.nombreSolicitante;
                            return (
                                <tr key={t.id} onClick={() => navigate(`/tickets/${t.id}`)}
                                    className="cursor-pointer hover:bg-blue-50/50 dark:hover:bg-gray-800/60 transition-colors">
                                    <td className="px-4 py-3 align-top font-mono text-xs font-semibold text-gray-500">#{t.id}</td>
                                    <td className="px-3 py-3 align-top max-w-[28rem]">
                                        <p className="font-semibold text-gray-900 dark:text-white line-clamp-2 leading-snug">{t.descripcion || 'Sin descripción'}</p>
                                        <p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400 truncate">{cat}{t.subcategoria?.nombre ? ` › ${t.subcategoria.nombre}` : ''}</p>
                                        <p className="mt-0.5 text-xs text-gray-500 lg:hidden truncate">{solicitante}</p>
                                    </td>
                                    <td className="px-3 py-3 align-top hidden lg:table-cell">
                                        <p className="text-gray-800 dark:text-gray-200 truncate max-w-[12rem]">{solicitante}</p>
                                        <p className="text-xs text-gray-500 truncate max-w-[12rem]">{t.departamento || t.empresa || 'General'}</p>
                                    </td>
                                    <td className="px-3 py-3 align-top">
                                        <span className={`inline-flex px-2 py-0.5 rounded border text-xs font-semibold ${PRIORIDAD[(t.prioridad || '').toLowerCase()] || 'border-gray-200 text-gray-600'}`}>{t.prioridad || '—'}</span>
                                    </td>
                                    <td className="px-3 py-3 align-top">
                                        <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${ESTADO[t.estado] || 'bg-gray-100 text-gray-700'}`}>{t.estado}</span>
                                    </td>
                                    <td className="px-3 py-3 align-top hidden md:table-cell">
                                        {agente ? (
                                            <span className="inline-flex items-center gap-1.5">
                                                <span className="w-6 h-6 rounded-full bg-amber-100 text-amber-800 text-[11px] font-bold flex items-center justify-center">{agente[0].toUpperCase()}</span>
                                                <span className="text-gray-800 dark:text-gray-200 truncate max-w-[10rem]">{agente}</span>
                                            </span>
                                        ) : (
                                            <span className="inline-flex items-center gap-2 whitespace-nowrap">
                                                <span className="text-xs text-gray-400">Sin asignar</span>
                                                {onAutoasignar && !['Resuelto', 'Cerrado'].includes(t.estado) && (puedeAutoasignar ? puedeAutoasignar(t) : true) && (
                                                    <button type="button" onClick={(e) => { e.stopPropagation(); onAutoasignar(e, t.id); }}
                                                        className="px-2 py-0.5 rounded-md text-[11px] font-semibold bg-indigo-600 text-white hover:bg-indigo-700">
                                                        Asignármelo
                                                    </button>
                                                )}
                                            </span>
                                        )}
                                    </td>
                                    <td className="px-4 py-3 align-top text-right hidden sm:table-cell whitespace-nowrap">
                                        <p className="text-gray-700 dark:text-gray-300 text-xs font-medium">{hace(t.fechaCreacion)}</p>
                                        <p className="text-[11px] text-gray-400">{t.fechaCreacion ? new Date(t.fechaCreacion).toLocaleDateString('es-CL') : ''}</p>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
